<template>
    <div style="width: 100%" >
<!--        <div class="type-area">-->

        <el-row  class="row"
                style="display: flex;justify-content: left;flex-wrap: wrap"
        >
            <el-col
                    class="col"
                    style="display: flex;justify-content: center;align-items: center;"
                    :xs="12"
                    :sm="12"
                    :md="6"
                    :lg="6"
                    :xl="6"
                    v-for="(item2, index2) in hxContentList"
                    :key="index2"
            >
                <div class="card">
                    <div class="photo"><img
                            :src="item2.url"
                            alt=""></div>
                    <h2>{{item2.title}}</h2>
                    <p class="ql-editor" style="padding: 0 !important;" v-if="item2.content" v-html="item2.content"></p>
                    <a>了解更多</a>
                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    export default {
        name: "shadow-list-index",
        props: {
            hxContentList: Array
        }
    }
</script>

<style lang="scss" scoped>

    @media screen and (min-width: 1400px) {
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .card {
            width: 100%;
            /*height: 450px;*/
            border-radius: 10px;
            margin: 10px 10px;
            aspect-ratio: 9/9
        }

        .row {
            margin: 0 25px !important;
        }

        /* 鼠标移入变小图 */
        .card:hover .photo {
            width: 70px;
            height: 70px;
        }

        .card h2 {
            margin-top: 100px;
            font-size: 16px;
        }

        .card p {
            font-size: 14px;
            text-indent: 2em;
        }

        .card a {
            font-size: 14px;
            padding: 8px 18px;
        }

        .card:hover .photo {
            top: 20px;
            border-radius: 50%;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
        }

        .col{
            padding: 0 30px;
        }
    }

    @media screen and (min-width: 1200px) {
        .card {
            width: 100%;
            /*height: 450px;*/
            border-radius: 10px;
            margin: 10px 10px;
            aspect-ratio: 9/9
        }

        .row {
            /*margin: 0 25px !important;*/
        }

        /* 鼠标移入变小图 */
        .card:hover .photo {
            width: 70px;
            height: 70px;
        }

        .card h2 {
            margin-top: 100px;
            font-size: 16px;
        }

        .card p {
            font-size: 14px;
            text-indent: 2em;
        }

        .card a {
            font-size: 14px;
            padding: 8px 18px;
        }

        .card:hover .photo {
            top: 20px;
            border-radius: 50%;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
        }

        .col{
            padding: 0 30px;
        }
    }

    @media screen and (max-width: 1200px) {
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .card {
            width: 100%;
            /*height: 350px;*/
            border-radius: 10px;
            margin: 10px 10px;
            aspect-ratio: 9/9;
        }

        .row {
            /*margin: 0 25px !important;*/
        }

        /* 鼠标移入变小图 */
        .card:hover .photo {
            width: 70px;
            height: 70px;
        }

        .card h2 {
            margin-top: 100px;
            font-size: 16px;
        }

        .card p {
            font-size: 14px;
            text-indent: 2em;
        }

        .card a {
            font-size: 14px;
            padding: 8px 18px;
        }

        .card:hover .photo {
            top: 20px;
            border-radius: 50%;
            box-shadow: 7px 7px 13px -1px rgba(0, 0,0, 0.2);
            /*box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);*/
        }


        .col{
            padding: 0 30px;
        }
    }

    @media screen and (max-width: 870px) {
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .card {
            width: 100%;
            /*height: 350px;*/
            border-radius: 10px;
            margin: 10px 10px;
            aspect-ratio: 9/9;

        }

        .row {
            /*margin: 0 25px !important;*/
        }

        /* 鼠标移入变小图 */
        .card:hover .photo {
            width: 70px;
            height: 70px;
        }

        .card h2 {
            margin-top: 100px;
            font-size: 16px;
        }

        .card p {
            font-size: 14px;
            text-indent: 2em;
        }

        .card a {
            font-size: 14px;
            padding: 8px 18px;
        }

        .card:hover .photo {
            top: 20px;
            border-radius: 50%;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
        }

        .col{
            padding: 0 10px;
        }
    }

    @media screen and (max-width: 570px) {
        .col{
            padding: 0 10px;
        }

        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .card {
            width: 100%;
            height: 200px;
            border-radius: 10px;
            margin: 10px 10px;
            aspect-ratio: 9/9;

        }

        .row {
            /*margin: 0 25px !important;*/
        }

        /* 鼠标移入变小图 */
        .card:hover .photo {
            width: 60px;
            height: 60px;
        }

        .card h2 {
            margin-top: 90px;
            font-size: 14px;
        }

        .card p {
            font-size: 12px;
        }

        .card a {
            font-size: 12px;
            padding: 8px 18px;
        }

        .card:hover .photo {
            top: 20px;
            border-radius: 50%;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
        }

        /*!* 鼠标移入变小图 *!*/
        /*.card:hover .photo {*/
        /*    top: 30px;*/
        /*    width: 120px;*/
        /*    height: 120px;*/
        /*    border-radius: 50%;*/
        /*    box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);*/
        /*}*/
    }

    .card {
        /* 相对定位 */
        position: relative;
        background-color: #758a99;
        /* 溢出隐藏 */
        overflow: hidden;
        /* 弹性布局 */
        display: flex;
        /* 元素纵向排列 */
        flex-direction: column;
        /* 居中 */
        align-items: center;
        color: #fff;
        /* 阴影 */
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
        /* 不让其被挤压 */
        flex-shrink: 0;
    }

    .card .photo img {
        width: 100%;
        height: 100%;
        /* 保持原有尺寸比例，裁切长边 */
        object-fit: cover;
    }

    /* 默认大图 */
    .card .photo {
        /* 绝对定位 */
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 0%;
        overflow: hidden;
        /* 动画过渡 */
        transition: 0.5s;
    }

    /* 鼠标移入变小图 */
    .card:hover .photo {
        border-radius: 50%;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
    }

    /* 这里加个黑色到透明的渐变背景，可以更好的看清楚名字 */
    .card .photo::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, transparent 50%, #222);
    }

    .card h2 {
        width: 80%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        text-align: center;
    }

    .card p {
        width: 96%;
        text-indent: 32px;
        margin-bottom: 15px;
        line-height: 30px;
    }

    .card a {
        color: rgba(255, 255, 255, 0.8);
        text-decoration: none;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 8px;
        margin-bottom: 10px;
    }

    .card a:hover {
        color: #fff;
        background-color: rgba(255, 255, 255, 0.2);
    }
</style>
